import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { UserCheck, UserPlus } from 'lucide-react';

function fecha(valor) {
  try {
    return new Date(valor).toLocaleDateString('es-AR');
  } catch {
    return '';
  }
}

/**
 * Toda entrevista va a la ficha de un alumno. Si ya hay alguien con el mismo
 * nombre, decide el profesional: es esa persona, o es otra (ficha nueva).
 * Nunca se une a dos personas solo porque se llaman igual.
 */
export default function ElegirAlumnoDialog({ abierto, nombre, candidatos = [], onElegir, onNueva, onCancelar }) {
  return (
    <AlertDialog open={abierto} onOpenChange={(v) => { if (!v) onCancelar(); }}>
      <AlertDialogContent data-testid="elegir-alumno">
        <AlertDialogHeader>
          <AlertDialogTitle>¿Es la misma persona?</AlertDialogTitle>
          <AlertDialogDescription>
            Ya tenés {candidatos.length === 1 ? 'un alumno' : 'alumnos'} con el nombre{' '}
            <strong>{nombre}</strong>. Elegí a qué ficha va esta entrevista.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          {candidatos.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => onElegir(c.id)}
              className="w-full flex items-center gap-3 text-left border border-slate-200 rounded-lg px-4 py-3 hover:border-[#1F3A5F]/40 hover:bg-slate-50 transition-colors"
              data-testid="elegir-alumno-existente"
            >
              <UserCheck className="h-5 w-5 text-[#1F3A5F] flex-shrink-0" />
              <span>
                <span className="block font-semibold text-slate-800">Sí, es {c.nombre}</span>
                <span className="block text-xs text-slate-500">
                  {c.entrevistas} {c.entrevistas === 1 ? 'entrevista' : 'entrevistas'}
                  {c.ultima_entrevista ? ` · la última, el ${fecha(c.ultima_entrevista)}` : ''}
                </span>
              </span>
            </button>
          ))}
          <button
            type="button"
            onClick={onNueva}
            className="w-full flex items-center gap-3 text-left border border-dashed border-slate-300 rounded-lg px-4 py-3 hover:bg-slate-50 transition-colors"
            data-testid="elegir-alumno-nuevo"
          >
            <UserPlus className="h-5 w-5 text-slate-500 flex-shrink-0" />
            <span>
              <span className="block font-semibold text-slate-800">No, es otra persona</span>
              <span className="block text-xs text-slate-500">Se crea una ficha nueva con este nombre.</span>
            </span>
          </button>
        </div>
        <div className="flex justify-end">
          <Button variant="ghost" onClick={onCancelar}>Volver</Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
